var ENUM = {
  // 证件类型
  certType: [{
    text: '居民身份证',
    value: 'ID_CARD'
  }, {
    text: '军官证',
    value: 'OFFICER'
  }, {
    text: '护照',
    value: 'PASSPORT'
  }, {
    text: '企业法人营业执照',
    value: 'BUSINESS_LICENSE'
  }, {
    text: '社团法人证书',
    value: 'CORPORATE'
  }, {
    text: '事业单位法人证书',
    value: 'INSTITUTION'
  }, {
    text: '组织机构代码证书',
    value: 'ORGANIZATION_CODE'
  }, {
    text: '其他',
    value: 'OTHER'
  }],

  /**
   * @description: 著作权人类型
   * @author Zyan Wlayor
   * @date 2020/6/11
   */
  CopyrightOwnerTypeEnum: [{
    text: '自然人',
    value: 'p'
  }, {
    text: '企业法人',
    value: 'o'
  }, {
    text: '机关法人',
    value: 'OFFICIAL'
  }, {
    text: '事业单位法人',
    value: 'BUSINESS_UNIT'
  }, {
    text: '社会团体法人',
    value: 'SOCIAL_ORGANIZATION'
  }, {
    text: '其他组织',
    value: 'OTHER_ORGANIZATION'
  }, {
    text: '其他',
    value: 'OTHER'
  }],

  /**
   * @description: 消费记录 - 消费事项 code
   * @author Zyan Wlayor
   * @date 2020/6/9
   *
   */
  sceneCode: [{
    text: '公证保全缴费',
    value: 'NOTARIZATION_COST'
  }, {
    text: '漫联盟存证',
    value: 'IP_MEN_SAVE_CERT'
  }, {
    text: '身份认证通过',
    value: 'GRANT_M_COIN_REWARD'
  }, {
    text: '漫联盟充值余额',
    value: 'IP_MEN_RECHARGE_BALANCE'
  }, {
    text: '版权经纪人缴费',
    value: 'COPYRIGHT_BROKER'
  }, {
    text: '漫联盟提现',
    value: 'IP_MEN_WITHDRAW'
  }, {
    text: '提现手续费',
    value: 'IP_MEN_WITHDRAW_HANDLING_FEE'
  }, {
    text: '代理商开卡',
    value: 'AGENT_OPEN_CARD'
  }, {
    text: '版权授权交易',
    value: 'AUTHORIZE_COPYRIGHT_AMOUNT'
  }, {
    text: '漫联盟线下汇款充值余额',
    value: 'IP_OFFLINE_TRANSFER_RECHARGE'
  }],

  /**
   * @description: 消费记录 - 支付状态
   * @author Zyan Wlayor
   * @date 2020/6/9
   */
  transStatus: [{
    value: 'SUCCESS',
    text: '支付成功',
    background: '#E8EDFE',
    color: '#3F6DFE'
  }, {
    value: 'FAIL',
    text: '已退回',
    color: '#7C7C7C',
    background: '#F8F8F8'
  }, {
    value: 'DEFAULT',
    text: '默认',
    background: '#E8EDFE',
    color: '#3F6DFE'
  }],

  /**
   * @description: 消费记录 - 交易类型
   * @author Zyan Wlayor
   * @date 2020/6/9
   */
  transType: [{
    value: 'INCOME',
    text: '收入',
    background: '#E8EDFE',
    color: '#3F6DFE'
  }, {
    value: 'CONSUMER',
    text: '消费',
    background: '#E8EDFE',
    color: '#3F6DFE'
  }, {
    value: 'REFUND',
    text: '退回',
    color: '#7C7C7C',
    background: '#F8F8F8'
  }],

  /**
   * @description: 消费记录 - 支付方式
   * @author Zyan Wlayor
   * @date 2020/6/9
   */
  payPlatform: [{
    value: 'AliPay',
    text: '支付宝支付'
  }, {
    value: 'WeChat',
    text: '微信支付'
  }, {
    value: 'U_COIN',
    text: 'U币支付'
  }, {
    value: 'M_COIN',
    text: 'M币支付'
  }],

  /**
   * @description: 存证审核状态
   * @author Zyan Wlayor
   * @date 2020/6/10
   */
  EvidenceAuditStatus: [{
    value: '2',
    text: '已存证',
    background: '#E8EDFE',
    color: '#3F6DFE'
  }, {
    value: '1',
    text: '待审核',
    background: '#E6FBFC',
    color: '#4FB6AF'
  }, {
    value: '0',
    text: '初始化',
    background: '#E6FBFC',
    color: '#4FB6AF'
  }, {
    value: '-1',
    text: '已拒绝',
    color: '#7C7C7C',
    background: '#F8F8F8'
  }],
  // 充值状态
  rechargeStatusEnum: [{
    text: '已到账',
    value: 'SUCCESS',
    color: 'blue'
  }, {
    text: '待充值',
    value: 'INIT',
    color: 'green'
  }, {
    text: '到账中',
    value: 'PAYING',
    color: 'green'
  }, {
    text: '已失败',
    value: 'FAIL',
    color: 'red'
  }, {
    text: '已失败',
    value: 'CLOSED',
    color: 'red'
  }],
  // 提现状态
  withdrawAuditStatusEnum: [{
    text: '待审核',
    value: 'INITIAL',
    background: '#E6FBFC',
    color: '#4FB6AF'
  }, {
    text: '已拒绝',
    value: 'REFUSED',
    color: '#7C7C7C',
    background: '#F8F8F8'
  }, {
    text: '已到账',
    value: 'COMPLETED',
    background: '#E8EDFE',
    color: '#3F6DFE'
  }],
  // 商户
  merchantEnum: [{
    value: 'ipBank',
    text: '漫联盟商户'
  }, {
    value: 'ubq',
    text: '优版权商户'
  }],
  rightExchangeStatusEnum: [{
    value: 'INIT',
    text: '生效中'
  }, {
    value: 'DONE',
    text: '已兑完'
  }, {
    value: 'EXPIRED',
    text: '已过期'
  }, {
    value: 'BLANK',
    text: '生效中'
  }],
  // 资产状态
  productStatus: [{
    value: '-1',
    text: '准备中'
  }, {
    value: '0',
    text: '待竞拍'
  }, {
    value: '1',
    text: '转售中'
  }, {
    value: '2',
    text: '收藏中'
  }, {
    value: '3',
    text: '已关闭'
  }, {
    value: '4',
    text: '已加入专题'
  }, {
    value: '5',
    text: '已销毁'
  }],
  dealType: [{
    value: 'RECHARGE',
    text: '充值'
  }, {
    value: 'WITHDRAW',
    text: '提现'
  }, {
    value: 'SERVICE',
    text: '服务'
  }, {
    value: 'TRANSACTION',
    text: '交易'
  }, {
    value: 'REFUND',
    text: '退还'
  }, {
    value: 'EARNINGS',
    text: '收益'
  }, {
    value: 'PRESENTATION',
    text: '赠送'
  }, {
    value: 'TRANSFER',
    text: '转移'
  }],
  couponTypeEnum: [{
    value: 'CASH_BACK',
    text: '返现券'
  }, {
    value: 'MATCH_REDUCTION',
    text: '满减券'
  }, {
    value: 'DISCOUNT',
    text: '折扣券'
  }],
  crowdfundingEnum: [{
    value: 'CROWD_FUNDING',
    text: '众筹中'
  }, {
    value: 'CROWD_FUNDING_SUCCEED',
    text: '众筹成功'
  }, {
    value: 'COMPLETED',
    text: '众筹成功'
  }, {
    value: 'CROWD_FAILED',
    text: '众筹失败'
  }],
  activityEnum: [{
    value: 'PAY_SUCCESS',
    text: '已付款'
  }, {
    value: 'REFUNDED',
    text: '已退款'
  }, {
    value: 'REFUNDING',
    text: '退款中'
  }, {
    value: 'WAIT_DELIVERY',
    text: '待发货'
  }, {
    value: 'DELIVERED',
    text: '待收货'
  }, {
    value: 'COMPLETE',
    text: '已完成'
  }]
};
export default ENUM;